(() => {
  if (window.__easePdp) return;
  window.__easePdp = true;

  // Slider arrows
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-ease-arrow]');
    if (!arrow) return;
    const track = arrow.closest('[data-ease-slider]').querySelector('[data-ease-track]');
    const slide = track.firstElementChild;
    const step = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth;
    track.scrollBy({ left: arrow.dataset.easeArrow === 'next' ? step : -step, behavior: 'smooth' });
  });

  // "Shop now" buttons scroll back to the buy box
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ease-to-buy]');
    if (!link) return;
    const target = document.querySelector('.ease-bundles, .product-info buy-buttons, .product-info');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // Count-up numbers
  const countUp = (el) => {
    const end = parseFloat(el.dataset.easeCount);
    if (isNaN(end)) return;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / 1200, 1);
      el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { countUp(entry.target); io.unobserve(entry.target); }
    });
  }, { threshold: 0.4 }) : null;
  const watch = () => document.querySelectorAll('[data-ease-count]:not([data-ease-watched])').forEach((el) => {
    el.setAttribute('data-ease-watched', '');
    io ? io.observe(el) : null;
  });
  // Timeline: steps fade in and the line fills as you scroll
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const timelines = [];
  const stepIo = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); stepIo.unobserve(entry.target); }
    });
  }, { threshold: 0.35 }) : null;
  const updateProgress = () => {
    const middle = window.innerHeight * 0.6;
    timelines.forEach((tl) => {
      const bar = tl.querySelector('.ease-tl__progress');
      if (!bar) return;
      const rect = tl.getBoundingClientRect();
      const p = Math.min(Math.max((middle - rect.top) / rect.height, 0), 1);
      bar.style.transform = `scaleY(${p})`;
    });
  };
  const watchTimelines = () => {
    if (reduceMotion || !stepIo) return;
    document.querySelectorAll('[data-ease-timeline]:not(.is-animated)').forEach((tl) => {
      tl.classList.add('is-animated');
      tl.querySelectorAll('.ease-tl__step').forEach((step) => stepIo.observe(step));
      timelines.push(tl);
    });
    updateProgress();
  };
  window.addEventListener('scroll', () => requestAnimationFrame(updateProgress), { passive: true });

  const init = () => { watch(); watchTimelines(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
